module.exports = __webpack_public_path__ + "img/ghb.67b35a3c.svg";